import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { supabase } from '../../lib/supabase';
import {
  Spinner,
  StatusBadge,
} from '../../components/design-system';
import { AdminPage } from './AdminPage';

interface ConversationRow {
  id: string;
  traveler_id: string;
  status: string;
  created_at: string;
  updated_at: string;
  profiles: { full_name: string | null } | null;
}

export function AdminConversations() {
  const { user } = useAuth();
  const [conversations, setConversations] = useState<ConversationRow[]>([]);
  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    setDataLoading(true);
    void supabase
      .from('conversations')
      .select('id, traveler_id, status, created_at, updated_at, profiles!conversations_traveler_id_fkey(full_name)')
      .order('created_at', { ascending: false })
      .then(({ data }) => {
        setConversations((data as unknown as ConversationRow[]) ?? []);
        setDataLoading(false);
      });
  }, [user]);

  return (
    <AdminPage title="Conversations" description="Alma onboarding chat sessions with travelers.">
      {dataLoading ? (
        <div className="flex justify-center py-12"><Spinner /></div>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-app-border bg-app-card shadow-sm">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-app-border bg-app-bg">
                <th className="text-left px-4 py-3 font-medium text-app-muted">Traveler</th>
                <th className="text-left px-4 py-3 font-medium text-app-muted">Status</th>
                <th className="text-left px-4 py-3 font-medium text-app-muted">Started</th>
                <th className="text-left px-4 py-3 font-medium text-app-muted">Last update</th>
              </tr>
            </thead>
            <tbody>
              {conversations.length === 0 && (
                <tr><td colSpan={4} className="px-4 py-6 text-center text-app-muted text-xs">No conversations yet.</td></tr>
              )}
              {conversations.map((c) => (
                <tr key={c.id} className="border-b border-app-border last:border-0 hover:bg-app-bg/50">
                  <td className="px-4 py-3 text-app-fg text-xs">
                    {c.profiles?.full_name ?? <span className="text-app-muted font-mono">{c.traveler_id.slice(0, 8)}…</span>}
                  </td>
                  <td className="px-4 py-3">
                    <StatusBadge status={c.status} />
                  </td>
                  <td className="px-4 py-3 text-app-muted text-xs">{new Date(c.created_at).toLocaleDateString()}</td>
                  <td className="px-4 py-3 text-app-muted text-xs">{new Date(c.updated_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminPage>
  );
}

export default AdminConversations;
